import { AudioFormat, } from '@zattoo/playback-sdk';
export const generateTrackId = (locale, audioFormat) => {
    return audioFormat
        ? `${locale}-${audioFormat}`
        : locale;
};
/**
 * Rakuten doesn't embed available audio tracks into the stream manifest
 */
export const processAvailableAudioTracksRakutenVod = (event, streamRequestInfo, capabilities) => {
    const streamingOptions = streamRequestInfo.streamingOptions;
    const flattenTracks = (audioFormat) => [...new Set(streamingOptions
            .filter((option) => option.audio_qualities.includes(audioFormat === AudioFormat.DOLBY ? '5.1' : '2.0'))
            .flatMap((option) => option.audio_language_codes))
            .values()]
        .map((locale) => ({
        id: generateTrackId(locale, audioFormat),
        locale,
        audioFormat,
    }));
    const availableAudioTracks = [
        ...flattenTracks(AudioFormat.STEREO),
        ...(capabilities.dolbySupported
            ? flattenTracks(AudioFormat.DOLBY)
            : []),
    ];
    return {
        ...event,
        tracks: availableAudioTracks,
    };
};
export const processAvailableAudioTracksRakutenVodTrailer = (event, streamRequestInfo) => {
    const availableAudioTracks = streamRequestInfo.audioLanguages
        .map((locale) => ({
        id: generateTrackId(locale),
        locale,
        audioFormat: AudioFormat.STEREO,
    }));
    return {
        ...event,
        tracks: availableAudioTracks,
    };
};
/**
 * We can't trust the audio language in Rakuten Manifests, because:
 * - they can be undefined
 * - they can be 3-letter codes instead of 2-letter codes
 */
export const processSelectedAudioTrackRakutenVod = (event, streamRequestInfo) => {
    if (!event.targetTrack) {
        return event;
    }
    const requestedLanguage = streamRequestInfo.watchRequestParams.lang;
    if (!requestedLanguage) {
        return event;
    }
    const targetTrack = {
        ...event.targetTrack,
        id: generateTrackId(requestedLanguage, event.targetTrack?.audioFormat),
        locale: requestedLanguage,
    };
    return {
        ...event,
        targetTrack,
    };
};
